import React from 'react';
import EmojiPicker from 'emoji-picker-react';

const EmojiPickerWrapper = ({ onEmojiClick, height, width }) => {

  const mode = localStorage.getItem('mode');
  const emojiTheme = mode === 'Dark' ? 'dark' : 'light';

  return (
    <EmojiPicker
      emojiStyle="google"
      theme={emojiTheme}
      height={height || 450}
      width={width || 350}
      autoFocusSearch={false}
      searchDisabled
      previewConfig={{ showPreview: false }}
      lazyLoadEmojis
      suggestedEmojisMode="recent"
      onEmojiClick={onEmojiClick}
    />
  );
};

export default EmojiPickerWrapper;
